import { render } from "./BrandStory.vue?vue&type=template&id=6338959a&scoped=true"
import script from "./BrandStory.vue?vue&type=script&lang=js"
export * from "./BrandStory.vue?vue&type=script&lang=js"

import "./BrandStory.vue?vue&type=style&index=0&id=6338959a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6338959a"]])

export default __exports__